import React from 'react';
import Tooltip from '@/components/common/Tooltip';
import styles from './TextToSpeechButton.module.scss';

interface LanguageSelectMenuProps {
  languages: string[],
  selectedLanguage: string,
  setLanguage: (language: string) => void,
}

const LanguageSelectMenu = ({ languages, selectedLanguage, setLanguage }: LanguageSelectMenuProps) => {
  const content = languages.map(language => (
    <button
      key={`language-${language}`}
      aria-label={`Select ${language}`}
      className={`dropdown-item ${styles.ttsSpeedButton}`}
      type="button"
      onClick={() => setLanguage(language)}
    >
      <span
        className={styles.ttsSpeedSelectText}
        style={{ visibility: selectedLanguage === language ? 'visible' : 'hidden' }}
      >
        <i className="fa fa-check" />
      </span>
      <span>{language}</span>
    </button>
  ));

  return (
    <Tooltip
      interactive
      arrow={false}
      content={<div style={{ display: 'block' }}>{content}</div>}
      distance={0}
      placement="bottom"
      theme="dropdown"
    >
      <button
        aria-label="Open language selection menu"
        className={`tw-py-[6px] tw-px-[10px] ${styles.ttsActionDropdown}`}
        type="button"
      >
        <i className="fa fa-caret-down" />
      </button>
    </Tooltip>
  );
};

export default LanguageSelectMenu;
